import { OnInit, Component, Input } from '@angular/core';
import { Router } from '@angular/router';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import {UserService} from "../../../core/user/user.service";

@Component({
  selector: 'app-modal-alert',
  templateUrl: './modal-alert.component.html',
  styleUrls: ['./modal-alert.component.scss'],
})
export class ModalAlertComponent implements OnInit {
  @Input() status: any;
  @Input() titile: any;
  @Input() message: any;
  @Input() description: any;
  userConnected?: any = {};
  constructor(private modalService: NgbModal, private userService: UserService, private router:Router) {}

  ngOnInit(): void {
    this.userConnected = this.userService.getUser();
  }
  home() {
    this.modalService.dismissAll()
    void this.router.navigateByUrl('/home');
  }

  closeModal() {
    this.modalService.dismissAll()
  }
}
